// Type definitions for label data
export interface LabelData {
  orderId: string;
  customerId: string;
  partNumber: string;
  description: string;
  poNumber: string;
  date: string;
}

export function generateDymoLabelXml(data: LabelData): string {
  // DYMO 30253 Address Labels: 1.125" x 3.5"
  // Layout matching CSS format

  return `<?xml version="1.0" encoding="utf-8"?>
<DieCutLabel Version="8.0" Units="twips">
  <PaperOrientation>Landscape</PaperOrientation>
  <Id>Address</Id>
  <IsOutlined>false</IsOutlined>
  <PaperName>30252 Address</PaperName>
  <Height>1620</Height>
  <Width>5040</Width>
  <Orientation>Landscape</Orientation>
  <PrinterName></PrinterName>
  <DrawCommands/>
  <ObjectInfo>
    <TextObject>
      <Name>TEXT</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName/>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Left</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>ShrinkToFit</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String xml:space="preserve">${escapeXml(formatLabelText(data))}</String>
          <Attributes>
            <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="115" Y="115" Width="4810" Height="1390"/>
  </ObjectInfo>
</DieCutLabel>`;
}

function formatLabelText(data: LabelData): string {
  // Format matching CSS layout
  // Line 1: Order ID, Customer ID (centered), Date
  // Line 2: Part Number, PO Number
  // Line 3+: Description (word wrapped by DYMO)

  const line1 = `${data.orderId}          ${data.customerId}          ${data.date}`;
  const line2 = `${data.partNumber}                    PO#: ${data.poNumber}`;
  const line3 = data.description;

  return `${line1}
${line2}

${line3}`;
}

function escapeXml(unsafe: string): string {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}
